import { render, staticRenderFns } from "./page-create-sleep-story.vue?vue&type=template&id=12acd038&"
import script from "./page-create-sleep-story.vue?vue&type=script&lang=ts&"
export * from "./page-create-sleep-story.vue?vue&type=script&lang=ts&"
import style0 from "./page-create-sleep-story.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports